import angular from 'angular';
import booksMenu from '../../menu/Menu';
import booksServices from '../../booksServices';
import booksDom from '../../booksDom';
import tagAdminTemplate from './tagAdmin.html';
import addChangeTagDialog from '../../com/AddChangeTagDialog/AddChangeTagDialog';
import booksData from '../../data/BooksData';
import './tagAdmin.scss';
/** Tag Admin Services */
import { TagAdminServiceProvider } from './services/Services';

/*******************************************************************************
 * @ngdoc overview
 * @name  tagAdmin
 *
 * @description
 * Provides a way of managing Tag records.
 *******************************************************************************/
export default angular
  .module('csm.books.tagAdmin', [
    booksMenu,
    booksServices,
    booksDom,
    addChangeTagDialog,
    booksData
  ])
  .controller('mainController', mainController)

  /*****************************************************************************
   * @ngdoc    component
   * @name     tagAdmin.component:tagAdmin
   * @description
   * The Tag Admin app component.
   *****************************************************************************/
  .component('tagAdmin', {
    template: tagAdminTemplate,
    controller: controller
  })
  .provider('Services', TagAdminServiceProvider).name;

/*****************************************************************************
 * @ngdoc    controller
 * @name     tagAdmin.controller:mainController
 * @description
 * Loads root scope and sets the appFlags.
 *****************************************************************************/
/* @ngInject */ function mainController($rootScope, $appFlags) {
  $rootScope.$appFlags = $appFlags;
}

/*******************************************************************************
 * controller */
/**
 * @ngdoc controller
 * @name  tagAdmin.tagAdmin.controller:controller
 * @description
 * Handles the main app. On first load, the grid is populated with the list of
 * available tags. By default, only tags that are displayed are shown. All tags
 * can be viewed by toggling the `Show Not Displayed` checkbox.
 *
 * The user can modify or delete existing tags by clicking on the icons on the
 * corresponding row for a given tag, or double clicking on the tag. The user
 * can also add a new tag.
 *******************************************************************************/
/* @ngInject */ function controller(
  $injector,
  $q,
  $scope,
  AddChangeTagDialog,
  Alert,
  BusyScreen,
  Services,
  SERVER,
  uiGridConstants
) {
  /** Instance Reference.                  */ var $ctrl = this;
  /** `Show Not Displayed` checkbox value. */ $ctrl.mChkNotDisplayed = false;
  /** Tag List.                            */ $ctrl.mTagList;

  /*------------------------------*/
  /* Set functions on controller. */
  /*------------------------------*/
  $ctrl.addTag = $injector.invoke(addTag, null, {
    $ctrl: $ctrl,
    $scope: $scope
  });
  $ctrl.changeTag = $injector.invoke(changeTag, null, {
    $ctrl: $ctrl,
    $scope: $scope
  });
  $ctrl.deleteTag = $injector.invoke(deleteTag, null, {
    $ctrl: $ctrl,
    $scope: $scope
  });
  $ctrl.loadTags = $injector.invoke(loadTags, null, {
    $ctrl: $ctrl,
    $scope: $scope
  });
  $ctrl.showNotDisplayed = $injector.invoke(showNotDisplayed, null, {
    $ctrl: $ctrl,
    $scope: $scope
  });

  /***************************************************************************
   * notDisplayedCellClass */
  /**
   * @ngdoc     method
   * @module    tagAdmin
   * @methodof  tagAdmin.controller:controller
   * @name      notDisplayedCellClass
   * @return    String  CSS class names.
   * @description
   * Used with cellClass property on all grid columns except Actions. Returns a
   * string of css classes to be applied to the columns.
   ***************************************************************************/
  function notDisplayedCellClass(grid, row, col) {
    var classNames = '';

    /*---------------------------------------------------------------*/
    /* Center text in the `Display Text` and `Display When` columns. */
    /*---------------------------------------------------------------*/
    classNames +=
      col.field == 'indicator' || col.field == 'showAssigned'
        ? 'text-center'
        : '';

    /*------------------------------------*/
    /* Grey and italize text in all cells */
    /* for tags that are not displayed.   */
    /*------------------------------------*/
    classNames +=
      !row.entity.showAssigned && !row.entity.showNotAssigned
        ? ' not-displayed-tag'
        : '';

    return classNames;
  }

  /*----------------------------------------------*/
  /* Template for the actions column in the grid. */
  /*----------------------------------------------*/
  var actionsTemplate =
    '<div class="ui-grid-cell-contents ng-binding ng-scope"> ' +
    '<table><tr>' +
    '<td style="width:25px;"><span style="cursor:pointer;" class="glyphicon glyphicon-edit  csm-grid-space-target" title="Change Tag" ng-click="grid.appScope.$ctrl.changeTag(row.entity)"></span></td>' +
    '<td style="width:25px;"><span style="cursor:pointer;" class="glyphicon glyphicon-trash csm-grid-space-target" title="Delete Tag" ng-click="grid.appScope.$ctrl.deleteTag(row.entity)"></span></td>' +
    '</tr></table>' +
    '</div>';

  /*--------------------------------------------------------*/
  /* Row template. Adds double click functionality to each  */
  /* grid row and gray text to tags that are not displayed. */
  /*--------------------------------------------------------*/
  var dblClickTemplate =
    '<div ng-dblclick="grid.appScope.$ctrl.changeTag(row.entity)"  \
            ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" \
                class="ui-grid-cell" ui-grid-cell> \
      </div>';

  /*------------------*/
  /* Items List grid. */
  /*------------------*/
  $ctrl.dgTags = {
    enableColumnMenus: false,
    enableRowHeaderSelection: false,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    rowTemplate: dblClickTemplate,
    multiSelect: false,
    onRegisterApi: function (gridApi) {
      $ctrl.dgTags.api = gridApi;
    },
    columnDefs: [
      {
        cellClass: notDisplayedCellClass,
        field: 'indicator',
        displayName: 'Display Text',
        width: 100
      },
      {
        cellClass: notDisplayedCellClass,
        field: 'description',
        displayName: 'Description',
        minWidth: 200
      },
      {
        cellClass: notDisplayedCellClass,
        field: 'displayCondition',
        displayName: 'Display When',
        width: 150
      },
      {
        cellClass: notDisplayedCellClass,
        field: 'assignedAfterDate',
        displayName: 'After',
        cellFilter: 'date:"MM/dd/yyyy"',
        type: 'date',
        width: 110
      },
      {
        cellClass: notDisplayedCellClass,
        field: 'assignedBeforeDate',
        displayName: 'Before',
        cellFilter: 'date:"MM/dd/yyyy"',
        type: 'date',
        width: 110
      },
      {
        appScope: $ctrl,
        cellTemplate: actionsTemplate,
        displayName: 'Actions',
        enableFiltering: false,
        enableSorting: false,
        field: 'actions',
        pinnedRight: true,
        minWidth: 75,
        width: 75
      }
    ]
  };

  /*--------------------------------------------------------*/
  /* Load the list of available tags to initialize the app. */
  /*--------------------------------------------------------*/
  BusyScreen.promise($ctrl.loadTags());
}

/*****************************************************************************
 * controller.addTag */
/**
 * @ngdoc     method
 * @module    tagAdmin
 * @methodof  tagAdmin.controller:controller
 * @name      addTag
 * @description
 * Display the dialog to add a new Tag.
 *****************************************************************************/
/* @ngInject */ function addTag($ctrl, AddChangeTagDialog, Alert) {
  return function () {
    AddChangeTagDialog.show()
      .then($ctrl.loadTags)
      .then(function () {
        Alert.success('The tag has been added', 'Tag created');
      });
  };
}

/*****************************************************************************
 * controller.changeTag */
/**
 * @ngdoc     method
 * @module    tagAdmin
 * @methodof  tagAdmin.controller:controller
 * @name      changeTag
 * @params    tag  Tag to modify.
 * @description
 * Display the dialog to modify an existing Tag.
 *****************************************************************************/
/* @ngInject */ function changeTag($ctrl, AddChangeTagDialog, Alert) {
  return function (tag) {
    if (!tag) {
      Alert.error('Nothing to modify');
      return;
    }

    AddChangeTagDialog.show(tag.id)
      .then($ctrl.loadTags)
      .then(function () {
        Alert.success('The tag has been modified', 'Tag updated');
      });
  };
}

/*****************************************************************************
 * controller.deleteTag */
/**
 * @ngdoc     method
 * @module    tagAdmin
 * @methodof  tagAdmin.controller:controller
 * @name      deleteTag
 * @param     tag  Tag to delete.
 * @description
 * Delete the provided tag.
 *****************************************************************************/
/* @ngInject */ function deleteTag($ctrl, Alert, BusyScreen, SERVER, Services) {
  return function (tag) {
    /*--------------------------*/
    /* Nothing to delete, exit. */
    /*--------------------------*/
    if (!tag) return;

    /*----------------------------------------------------*/
    /* Membership tags are required and cannot be removed */
    /*----------------------------------------------------*/
    if (tag.isMembership || tag.isLifetime) {
      Alert.info(
        'This is a required tag and cannot be removed.',
        'Cannot Remove'
      );
      return;
    }

    /*-------------------------*/
    /* Confirm and delete tag. */
    /*-------------------------*/
    Alert.confirm(
      "Are you sure you want to delete '" +
        (tag.isIndicator || 'this tag') +
        "'?",
      'Confirm Delete'
    ).then(function () {
      BusyScreen.promise(
        Services.drop(tag.id)
          .then($ctrl.loadTags)
          .then(
            function () {
              Alert.success('Delete Successful');
            },
            function (resp) {
              Alert.error(resp.parsedResponse.message(), 'Delete Error');
            }
          )
      );
    });
  };
}

/*****************************************************************************
 * controller.loadTags */
/**
 * @ngdoc     method
 * @module    tagAdmin
 * @methodof  tagAdmin.controller:controller
 * @name      loadTags
 * @return          Promise that resolves when data has been retrieved.
 * @description
 * Load the list of tags and populate the grid.
 *****************************************************************************/
/* @ngInject */ function loadTags(Services, $ctrl, BooksData) {
  return function () {
    return Services.getTagList().then(function (list) {
      $ctrl.mTagList = list.map((item) => new BooksData.Tag(item));
      $ctrl.showNotDisplayed($ctrl.mChkNotDisplayed);
    });
  };
}

/*****************************************************************************
 * controller.showNotDisplayed */
/**
 * @ngdoc     method
 * @module    tagAdmin
 * @methodof  tagAdmin.controller:controller
 * @name      showNotDisplayed
 * @param     value  Checkbox value to set.
 * @description
 * Getter/setter for the `Show Not Displayed` checkbox. When the checkbox value
 * changes, the grid is refreshed using the passed in value.
 *****************************************************************************/
/* @ngInject */ function showNotDisplayed($ctrl) {
  return function (value) {
    /*---------------------------------------------------*/
    /* No arguments, getter called. Return cached value. */
    /*---------------------------------------------------*/
    if (!arguments.length) return $ctrl.mChkNotDisplayed;

    /*----------------------------------------------*/
    /* Tag list has not been loaded, nothing to do. */
    /*----------------------------------------------*/
    if (!$ctrl.mTagList) return;

    /*--------------------*/
    /* Populate the grid. */
    /*--------------------*/
    $ctrl.dgTags.data = $ctrl.mTagList.filter(function (t) {
      return value || t.showAssigned || t.showNotAssigned;
    });

    /*-----------------------*/
    /* Cache checkbox value. */
    /*-----------------------*/
    $ctrl.mChkNotDisplayed = value;
  };
}
